"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.alertOnError = void 0;
var error_stack_parser_1 = __importDefault(require("error-stack-parser"));
var server_1 = require("../server");
var LOGR_CLIENT_SIDE_URL = 'https://www.deviantart.com/_puppy/util/ddt';
var LOGR_CLIENT_SIDE_URL_LOCAL = 'https://www.deviantart.lan/_puppy/util/ddt';
function alert(name, message, tags, data) {
    if (server_1.isSSR() || window.hasOwnProperty('__DDT_UNSUPPORTED_BROWSER')) {
        return;
    }
    var payload = {
        error: message,
        data: __assign({ browser: {
                userAgent: navigator && navigator.userAgent,
                location: location && location.href,
                referrer: document && document.referrer,
            }, app: (window && window['__APP_INFO__']) || 'unknown' }, data),
        tags: __spreadArrays(tags, [(window && window['__APP_INFO__'])]),
    };
    var endpoint = LOGR_CLIENT_SIDE_URL;
    if (process.env.NODE_ENV !== 'production' || process.env.XHR_ENV === 'vm') {
        endpoint = window.location.origin + "/_puppy/util/ddt";
    }
    else if (window['__XHR_LOCAL__']) {
        endpoint = LOGR_CLIENT_SIDE_URL_LOCAL;
    }
    var xhr = new XMLHttpRequest();
    xhr.open('POST', endpoint);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.send(JSON.stringify({ payload: payload }));
}
exports.default = alert;
/** Parses the backtrace from an error and includes it in the logr post `data` */
function alertOnError(error, name, message, tags, data) {
    if (data === void 0) { data = {}; }
    return alert(name, message, tags, __assign({ stacktrace: error && error_stack_parser_1.default.parse(error) }, data));
}
exports.alertOnError = alertOnError;
//# sourceMappingURL=alert.js.map